define(['angular'], function(angular) {
    'use strict';

    var MODULE_NAME = 'ilmn-ui-loading-animation';

    return angular
        .module(MODULE_NAME, [])
        .name;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-loading-animation/module.js
// module id = 31
// module chunks = 0 2